import { getAccessToken } from './authTokens';

const SKEW_SECONDS = 60;

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    const json = atob(base64);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** True if token is missing exp or exp is in the past (with skew). */
export function isJwtExpired(token: string, skewSeconds = SKEW_SECONDS): boolean {
  const payload = decodeJwtPayload(token);
  const exp = payload?.exp;
  if (typeof exp !== 'number') return true;
  return Date.now() >= (exp + skewSeconds) * 1000;
}

/** User can use protected routes only when access token is still valid. */
export function hasValidAuthSession(): boolean {
  const access = getAccessToken();
  if (!access) return false;
  return !isJwtExpired(access);
}
